import { Injectable } from '@angular/core';
import { DashboardItem } from '@dashboards/models/dashboard-item';
import { MathematicalHelperService } from '@common/services/mathematical-helper-service';

@Injectable()
export class DashboardHelperService {

  constructor(private readonly mathsHelper: MathematicalHelperService) {}

  setNewItemAxis(newItem: DashboardItem, items: DashboardItem[]) {
    const yAxisOfLastRow = this.mathsHelper.getMaxValue('y', items);
    const itemsOnLastRow = items.filter(i => i.y === yAxisOfLastRow);
    const maxColumns = 12; // The maximum number of columns gridster allows
    const availableColumnsOnLastRow = maxColumns - this.mathsHelper.getSumOfAll('cols', itemsOnLastRow);
    if (items.length === 0 || itemsOnLastRow.length === 0) return;

    // Can the new widget fit on the current last row?
    if (availableColumnsOnLastRow >= newItem.cols) {
      // Yes. Place the new widget on the current last row.
      const xAxisOfFarRightWidget = this.mathsHelper.getMaxValue('x', itemsOnLastRow);
      const farRightWidget = itemsOnLastRow.find(i => i.x === xAxisOfFarRightWidget);
      if (!farRightWidget) return;
      newItem.x = farRightWidget.x + farRightWidget.cols;
      newItem.y = yAxisOfLastRow;
    } else {
      // No. Place the new widget on a new row.
      const heightOfLastRow = this.mathsHelper.getMaxValue('rows', itemsOnLastRow);
      newItem.x = 0;
      newItem.y = yAxisOfLastRow + heightOfLastRow;
    }
  }
}
